
    var riot = require('riot')
    import $ from 'static/script/libs/jquery';
riot.tag2('modal', '<div class="modal-background modal-default" onclick="{_internalClose}" data-modal-close-trigger riot-style="{\'display: none;\': hide}; opacity: 1;"> <div class="modal {opts.styleClass}" style="margin-top: 0px;" data-modal="{opts.modalId}"> <yield></yield> </div> </div>', '', '', function(opts) {
        var self = this;
        self.hide = true;

        this.on('open-modal', function () {
            self.open();
        });

        function isCloseTrigger(element) {
            return !!element.attributes['data-modal-close-trigger'];
        }

        this.on('update', function () {
            if (this.opts.show) {
                this.hide = !this.opts.show;
            }
        }.bind(this));

        this.on('updated', function () {
            adjustPosition(this.opts.modalId);
        }.bind(this));

        function adjustPosition(modalId) {
            var modal = $('[data-modal="' + modalId + '"]');
            var popupHeight = modal.height();
            if (popupHeight < 0) {
                return;
            }
            var scroll = $(document).scrollTop();
            var windowHeight = window.innerHeight || document.documentElement.clientHeight;

            if (popupHeight > windowHeight) {
                modal.css('margin-top', scroll);
            } else {
                var targetOffset = (windowHeight - popupHeight) * 0.30;
                modal.css('margin-top', targetOffset + scroll);
            }
        }

        this.open = function () {
            self.hide = false;
            self.update();
        }.bind(this);

        this.close = function () {
            self.hide = true;
            self.update();
        }.bind(this);

        this._internalClose = function (evt) {
            if (isCloseTrigger(evt.target)) {
                self.hide = true;
            } else {
                return true;
            }
            self.update();
            if (_.isFunction(this.opts.onclose)) {
                this.opts.onclose();
            }
        }.bind(this);
});
    
  


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/tags/modal.riot.html